import {GoogleIcon} from "@/features/auth/components/GoogleIcon.jsx";
import {Button} from "@mui/joy";
import {useSignInWithGoogle} from "react-firebase-hooks/auth";
import {auth} from "@/features/auth/firebase.js";

export function GoogleButton() {
  const [signInWithGoogle, , loading] = useSignInWithGoogle(auth);

  return (
    <Button
      variant="outlined"
      color="neutral"
      size="lg"
      fullWidth
      startDecorator={!loading && <GoogleIcon/>}
      loading={loading}
      onClick={() => signInWithGoogle()}      
    >
      Continue with Google
    </Button>
  )
}